import moment from "moment";
import { Overlay } from "./styles"

interface Props {
    valorBruto:any,
    valorLiquido:any,
    Status:any,
    dataPagamento:any,
    FormaPagamento:any,
    entradaId:any,
    Cliente:any,
    Contrato:any,
    editarEntrada:any
}

export default function CommentBox ({
    valorBruto,
    valorLiquido,
    Status,
    dataPagamento,
    FormaPagamento,
    Cliente,
    Contrato,
    entradaId,
    editarEntrada

}:Props) {

    return (
        <Overlay>
            <div className="comment-box">
                <div className="comment-icon">💬{Cliente} {Contrato}</div>
                <div className="comment-text">
                    Valor Bruto: 
                    <b>{parseFloat(valorBruto).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</b>
                    <br />
                    Valor Liquido: <b>{parseFloat(valorLiquido).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</b>
                    <br />
                    Status: <b style={{textTransform:'uppercase'}}>{Status}</b>
                    <br />
                    Data de Pagamento: <b>{Status == 'pago' && moment(dataPagamento).format('DD/MM/YYYY')}</b>
                    <br /> 
                    Forma de Pagamento: <b>{FormaPagamento}</b>
                    <br /> 
                    
                </div>
                <div className="comment-button">
                    <button type="button" style={{display:'inline-block',height:'30px', textAlign:'center', alignItems:'center', width:'50%'}} className="btn btn-success" onClick={editarEntrada}>Editar Entrada</button>
                </div>
            </div>
        </Overlay>
      
    );
}

